import { render } from "./ResetPasswordPage.vue?vue&type=template&id=fd7e8b34&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/ResetPasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd7e8b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd7e8b34', __exports__)) {
    api.reload('fd7e8b34', __exports__)
  }
  
  module.hot.accept("./ResetPasswordPage.vue?vue&type=template&id=fd7e8b34&ts=true", () => {
    api.rerender('fd7e8b34', render)
  })

}


export default __exports__